import React from 'react';
import { connect } from 'react-redux';
import DocumentMeta from 'react-document-meta';
import styled from 'styled-components';
import {getRaceDetails, selectEvent, syncFavorites, switchRace} from '../actions/race';
import Leaderboard from './Leaderboard';
import Favorites from './Favorites';
import Results from './Results';
import SearchResults from './SearchResults';
import Question from './Question';
import ResultsHeader from './ResultsHeader';
import Loading from './Loading';
import RaceClock from './RaceClock';

class Race extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedTab: this.props.selectedTab || 'results',
      division: ''
    };

    // console.log(this.state);
  }

  componentWillMount() {

    this.props.syncFavorites(this.props.match.params.raceId);
    if (this.props.match.params.raceId) {
      this.props.getRaceDetails(this.props.match.params.raceId);
      this.props.selectEvent(this.props.match.params.eventId);
    }
  }

  componentDidMount() {

    if (this.props.raceDetail && this.props.raceDetail.name) {
      document.title = `RaceResults 360 - ${this.props.raceDetail.name}`;
    }

  }

  componentDidUpdate(oldProps){

    if (!this.props.noEvent && !this.props.match.params.eventId && this.props.raceDetail.event_mapping) {

      if (this.props.match.params.raceId === this.props.raceDetail.race_id) {

        const keys = this.props.raceDetail.event_mapping.map(x => x.key);
        const eventId = keys.length > 0 ? keys[0] : '';
        this.props.history.push(`/race/${this.props.match.params.raceId}/${eventId}/`);
        return;
      }
    }

    if (this.props.match.params.raceId !== oldProps.match.params.raceId) {
      this.props.switchRace(this.props.match.params.raceId);
      this.props.syncFavorites(this.props.match.params.raceId);
    }
    if (this.props.match.params.raceId !== oldProps.match.params.raceId || this.props.match.params.eventId !== oldProps.match.params.eventId) {
      this.props.selectEvent(this.props.match.params.eventId);
    }

    if (this.props.match.params.division && this.props.match.params.division !== oldProps.match.params.division) {
      this.setState({selectedTab: 'searchResults'});
    }

    if (this.props.selectedTab && (oldProps.selectedTab && oldProps.selectedTab !== this.props.selectedTab) && this.props.selectedTab !== this.state.selectedTab) {
      this.setState({selectedTab: this.props.selectedTab});
    }

    if (this.props.noEvent) {
      this.props.selectEvent('');
    }

    if (this.props.raceDetail && this.props.raceDetail.name) {
      document.title = `RaceResults 360 - ${this.props.raceDetail.name}`;
    }
  }


  updateTab(newTab) {
    this.setState({selectedTab: newTab});
  }

  handleSearch() {
    this.setState({selectedTab: 'searchResults'});
  }



  render() {

    const {raceDetail} = this.props;

    if (!raceDetail || !raceDetail.name) return (<Loading />);

    const noLeaderboard = this.props.raceDetail.options_leaderboard_ui === false;

    let selectedTab = this.state.selectedTab;
    if (selectedTab === 'leader' && noLeaderboard) {
      selectedTab = 'results'
    }

    let date = '';
    try {
      const [f1] = raceDetail.event_date.split('T')
      const [year, month, day] = f1.split('-');
      date = `${month}-${day}-${year}`;
    } catch(err) {
      // Do nothing
    }

    const meta = {
      title: document.title,
      description: `Online Race Results for ${raceDetail.name} a ${raceDetail.event_type} event. Powered by RaceResults 360.`,
      canonical: location.href,
      meta: {
        charset: 'utf-8',
        name: {
          keywords: `raceresults360,${raceDetail.name},${raceDetail.event_type},${raceDetail.city},${raceDetail.state},${raceDetail.country},athletes,runners,triathletes`
        }
      }
    };

    const ColorThemeHoverA = styled.a`
      color: #6c6b6b !important;

      &:hover {
        color: ${this.props.color} !important;
      }
    `;

    const ColorThemeA = styled.a`
      background: ${this.props.color} !important;
    `;

    // console.log(this.state);
    return (
    <div>
      <DocumentMeta {...meta} />
      <div className="intro clearfix">
        {/*<div className="intro-image hide">*/}
          {/*<a href="#">*/}
            {/*<img src="../styles/images/temp/intro.jpg" alt="" />*/}
          {/*</a>*/}
        {/*</div>*/}

        <div className="intro-inner">
          <div className="intro-content">
            <h3 className="intro-title">
              {this.props.singleEvent ? (
                <span>{raceDetail.name}</span>
              ): (
                <ColorThemeHoverA href="#">{raceDetail.name}</ColorThemeHoverA>
              )}
            </h3>

            <p className="intro-meta">
              {date} <span dangerouslySetInnerHTML={{__html: '&nbsp;'}} />  {`${raceDetail.city}, ${raceDetail.state}`} <span dangerouslySetInnerHTML={{__html: '&nbsp;'}} />
              {raceDetail.options_display_country ? ` ${raceDetail.country}` : ''}
            </p>
          </div>

          {this.props.raceDetail.options_ui_social_widget && this.props.raceDetail.options_ui_social_widget !== 'false' &&
            <div className="socials">
              <ul style={{marginBottom: "10px"}}>
                <li>
                  <a href={`http://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(location.href)}`} onClick={(e) => {
                      e.preventDefault();
                    window.open(`http://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(location.href)}`, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
                    return false;
                    }} className="link-facebook">facebook</a>
                </li>

                <li>
                  <a href={`https://twitter.com/share?url=${encodeURIComponent(location.href)}&text=${document.title}`} onClick={(e) => {
                      e.preventDefault();
                      window.open(`https://twitter.com/share?url=${encodeURIComponent(location.href)}&text=${document.title}`, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=254,width=600');
                      return false;
                    }} className="link-twitter" target="_blank">twitter</a>
                </li>

                <li>
                  <a href={`https://plus.google.com/share?url=${encodeURIComponent(location.href)}`} onClick={(e) => {
                      e.preventDefault();
                      window.open(`https://plus.google.com/share?url=${encodeURIComponent(location.href)}`, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=254,width=515');
                      return false;
                    }} className="link-google">google</a>
                </li>
              </ul>
            </div>
          }

          <div className="race-clock-container">
            <RaceClock />
          </div>


        </div>
      </div>

      <div className="nav">
        <ul className="clearfix">
          {!noLeaderboard &&
          <li className={`eventTab leader ${selectedTab === 'leader' ? 'current' : ''}`} data-tabid="leader"
              onClick={this.updateTab.bind(this, 'leader')}>
            <a className="gray" href={`#/race/${this.props.raceDetail.race_id}/${this.props.eventId || ''}/`}>Leaders</a>
          </li>
          }

          <li id="tab-results" className={`eventTab results ${selectedTab === 'results' || selectedTab === 'searchResults' ? 'current' : ''}`} data-tabid="results"  onClick={this.updateTab.bind(this, 'results')}>
            <a className="gray" href={`#/race/${this.props.raceDetail.race_id}/${this.props.eventId || ''}/results/`}>Results</a>
          </li>

          <li className={`eventTab favorites last ${selectedTab === 'favorites' ? 'current' : ''}`} data-tabid="favorites" onClick={this.updateTab.bind(this, 'favorites')}>
            <a className="gray" href={`#/race/${this.props.raceDetail.race_id}/${this.props.eventId || ''}/favorites`}>Favorites</a>
          </li>

          <li className={`eventTab link-red ${selectedTab === 'questions' ? '' : ''}`} data-tabid="questions" onClick={this.updateTab.bind(this, 'questions')}>
            <ColorThemeA href={`#/race/${this.props.raceDetail.race_id}/${this.props.eventId || ''}/questions`}  >Questions About Results?</ColorThemeA>
          </li>
        </ul>
      </div>

      <div className="main">
        <div id="tabContent">
          <ResultsHeader history={this.props.history} onSearch={this.handleSearch.bind(this)} division={this.props.match.params.division} />

          {selectedTab === 'leader' &&
            <Leaderboard history={this.props.history} updateTab={this.updateTab.bind(this)} />
          }

          {selectedTab === 'results' &&
            <Results history={this.props.history} />
          }

          {selectedTab === 'favorites' &&
            <Favorites history={this.props.history} />
          }

          {selectedTab === 'questions' &&
            <Question history={this.props.history} />
          }

          {selectedTab === 'searchResults' &&
            <SearchResults history={this.props.history} match={this.props.match} />
          }

        </div>
      </div>
    </div>
  );
  }
}

function mapStateToProps(state) {
  return {
    raceDetail: state.rr360.raceDetail,
    eventId: state.rr360.eventId,
    singleEvent: state.rr360.singleEvent,
    color: state.rr360.theme.primaryColor
  };
}


export default connect(mapStateToProps, {getRaceDetails, selectEvent, syncFavorites, switchRace})(Race);



// WEBPACK FOOTER //
// ./src/components/Race.js